import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { GroupsRounded } from '@mui/icons-material';

type ActionResponse = { id: string }[];
type ActionArgs = { search?: string };

export type AndieGetWorkspaceCompetitorsProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieGetWorkspaceCompetitors = (props: AndieGetWorkspaceCompetitorsProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.get-workspace-competitors.title')}
            icon={<GroupsRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.get-workspace-competitors.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.get-workspace-competitors.complete', {
                    value: result && Array.isArray(result) ? result.length : 0,
                })
            }
            {...props}
        />
    );
};

export default AndieGetWorkspaceCompetitors;
